// Reducer for the details of a topic.

import * as ActionTypes from '../constants/action_types'
import { DefaultState } from './DefaultState'
import * as ReducerUtils from './utils'

export const DefaultHomepageListState = {
  ...DefaultState
}

export const homepageList = ReducerUtils.makeSingleObjectReducer({
  defaultState: DefaultHomepageListState,
  actionRequest: ActionTypes.REQUEST_HOMEPAGE,
  actionFailure: ActionTypes.REQUEST_HOMEPAGE_FAILURE,
  actionReceive: ActionTypes.RECEIVE_HOMEPAGE,
  actionInvalidate: ActionTypes.INVALIDATE_HOMEPAGE
})

export const DefaultHomepageTopicDetailsState = {
  ...DefaultState
}

export const homepageTopicDetails = ReducerUtils.makeSingleObjectReducer({
  defaultState: DefaultHomepageTopicDetailsState,
  actionRequest: ActionTypes.REQUEST_HOMEPAGE_TOPIC_DETAILS,
  actionFailure: ActionTypes.REQUEST_HOMEPAGE_TOPIC_DETAILS_FAILURE,
  actionReceive: ActionTypes.RECEIVE_HOMEPAGE_TOPIC_DETAILS,
  actionInvalidate: ActionTypes.INVALIDATE_HOMEPAGE_TOPIC_DETAILS
})

export const DefaultHomepageTopicPlanState = {
  ...DefaultState
}

export const homepageTopicPlan = ReducerUtils.makeSingleObjectReducer({
  defaultState: DefaultHomepageTopicPlanState,
  actionRequest: ActionTypes.REQUEST_HOMEPAGE_TOPIC_PLAN,
  actionFailure: ActionTypes.REQUEST_HOMEPAGE_TOPIC_PLAN_FAILURE,
  actionReceive: ActionTypes.RECEIVE_HOMEPAGE_TOPIC_PLAN,
  actionInvalidate: ActionTypes.INVALIDATE_HOMEPAGE_TOPIC_PLAN
})

export const DefaultEngagementNetworkState = {
  ...DefaultState
}

export const homepageEngagementNetwork = ReducerUtils.makeSingleObjectReducer({
  defaultState: DefaultEngagementNetworkState,
  actionRequest: ActionTypes.REQUEST_HOMEPAGE_ENGAGEMENT_NETWORK,
  actionFailure: ActionTypes.REQUEST_HOMEPAGE_ENGAGEMENT_NETWORK_FAILURE,
  actionReceive: ActionTypes.RECEIVE_HOMEPAGE_ENGAGEMENT_NETWORK,
  actionInvalidate: ActionTypes.INVALIDATE_HOMEPAGE_ENGAGEMENT_NETWORK
})

export const DefaultDemographicsState = {
  ...DefaultState
}

export const homepageDemographics = ReducerUtils.makeSingleObjectReducer({
  defaultState: DefaultDemographicsState,
  actionRequest: ActionTypes.REQUEST_HOMEPAGE_DEMOGRAPHICS,
  actionFailure: ActionTypes.REQUEST_HOMEPAGE_DEMOGRAPHICS_FAILURE,
  actionReceive: ActionTypes.RECEIVE_HOMEPAGE_DEMOGRAPHICS,
  actionInvalidate: ActionTypes.INVALIDATE_HOMEPAGE_DEMOGRAPHICS
})

export const DefaultWhatsNewState = {
  ...DefaultState
}

export const homepageWhatsNew = ReducerUtils.makeSingleObjectReducer({
  defaultState: DefaultWhatsNewState,
  actionRequest: ActionTypes.REQUEST_HOMEPAGE_WHATS_NEW,
  actionFailure: ActionTypes.REQUEST_HOMEPAGE_WHATS_NEW_FAILURE,
  actionReceive: ActionTypes.RECEIVE_HOMEPAGE_WHATS_NEW,
  actionInvalidate: ActionTypes.INVALIDATE_HOMEPAGE_WHATS_NEW
})

export const DefaultTopShowsState = {
  ...DefaultState
}

export const homepageTopShows = ReducerUtils.makeSingleObjectReducer({
  defaultState: DefaultTopShowsState,
  actionRequest: ActionTypes.REQUEST_HOMEPAGE_TOP_SHOWS,
  actionFailure: ActionTypes.REQUEST_HOMEPAGE_TOP_SHOWS_FAILURE,
  actionReceive: ActionTypes.RECEIVE_HOMEPAGE_TOP_SHOWS,
  actionInvalidate: ActionTypes.INVALIDATE_HOMEPAGE_TOP_SHOWS
})

export const DefaultTrendingVideosState = {
  ...DefaultState
}

export const homepageTrendingVideos = ReducerUtils.makeSingleObjectReducer({
  defaultState: DefaultTrendingVideosState,
  actionRequest: ActionTypes.REQUEST_HOMEPAGE_TRENDING_VIDEOS,
  actionFailure: ActionTypes.REQUEST_HOMEPAGE_TRENDING_VIDEOS_FAILURE,
  actionReceive: ActionTypes.RECEIVE_HOMEPAGE_TRENDING_VIDEOS,
  actionInvalidate: ActionTypes.INVALIDATE_HOMEPAGE_TRENDING_VIDEOS
})


export const DefaultAnticipatedShowsState = {
  ...DefaultState
}

export const homepageAnticipatedShows = ReducerUtils.makeSingleObjectReducer({
  defaultState: DefaultTrendingVideosState,
  actionRequest: ActionTypes.REQUEST_HOMEPAGE_ANTICIPATED_SHOWS,
  actionFailure: ActionTypes.REQUEST_HOMEPAGE_ANTICIPATED_SHOWS_FAILURE,
  actionReceive: ActionTypes.RECEIVE_HOMEPAGE_ANTICIPATED_SHOWS,
  actionInvalidate: ActionTypes.INVALIDATE_HOMEPAGE_ANTICIPATED_SHOWS
})